import React, { FC } from "react";
import { CategorizationWithConfig } from "../../../../configMap/interfaces/category";
import useFixedCategorizationCell from "../../../hooks/useFixedCategorizationCell";
import CategorizationCellUI from "./CategorizationCellUI";

type Props = {
  disabled: boolean;
  categorizationWithConfig: CategorizationWithConfig;
  index: number;
  groupBlockId?: string;
};

const FixedCategorizationCellWrapper: FC<Props> = ({
  disabled,
  categorizationWithConfig,
  index,
  groupBlockId,
}) => {
  const {
    selectRef,
    handleChange,
    selectedCategory,
    categorizationOptions,
    handleSearch,
    handleFilter,
    isCategorizationDisabledByParent,
    disabledParentTooltip,
    isIncomplete,
    emptySearchResult,
    loading,
    isLoadingValue,
    handleKeyEvent,
    onFocus,
    onBlur,
    className,
  } = useFixedCategorizationCell(
    categorizationWithConfig,
    index,
    groupBlockId,
    disabled,
  );

  return (
    <CategorizationCellUI
      disabled={disabled}
      selectedCategory={selectedCategory}
      categorizationOptions={categorizationOptions}
      handleChange={handleChange}
      isCategorizationDisabledByParent={isCategorizationDisabledByParent}
      disabledParentTooltip={disabledParentTooltip}
      isIncomplete={isIncomplete}
      emptySearchResult={emptySearchResult}
      loading={loading}
      isLoadingValue={isLoadingValue}
      onFocus={onFocus}
      onBlur={onBlur}
      onSearch={handleSearch}
      filterOption={handleFilter}
      className={className}
      selectRef={selectRef}
      onKeyDown={handleKeyEvent}
      displayLabel={Boolean(
        categorizationWithConfig.categorization.search?.displayLabel,
      )}
    />
  );
};

export default FixedCategorizationCellWrapper;
